import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from './store';
import { navIdToPath } from './types/auth';

const RootRedirect: React.FC = () => {
  const member = useSelector((state: RootState) => state.auth?.member);
  const navigate = useNavigate();

  useEffect(() => {
    if (!member) {
      navigate('/dashboard', { replace: true });
      return;
    }
    const isAdmin = member?.roleType === 'ADMIN' || member?.roleType === 'Admin';
    if (isAdmin) {
      navigate('/admin/dashboard', { replace: true });
      return;
    }
    const activeNav = localStorage.getItem('maatra-active-nav-item');
    const redirectPath = '/dashboard';
    navigate(redirectPath, { replace: true });
  }, [member, navigate]);

  return null;
};

export default RootRedirect;
